import React from 'react';
import LoadingStyled from './loading.styled';
import LoadingProps from './types';

const Loading = (props: LoadingProps) => {
  return <LoadingStyled {...props} />;
};

Loading.defaultProps = {
  $fullScreen: false,
};

Loading.displayName = 'Loading';
Loading.Style = LoadingStyled;

export default Loading;
